<div class="contenedor-spinner">


    <div class="spinner">
        <img src="../../../../assets/img/logo_KeepClean.png" alt="">
    </div>

</div>